import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function MarkdownView({ children, className = "" }) {
  return (
    <div className={`md-content text-slate-200 leading-relaxed ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: (p) => <h1 className="text-3xl font-extrabold text-white mt-6 mb-4" {...p} />,
          h2: (p) => <h2 className="text-2xl font-bold text-white mt-8 mb-3" {...p} />,
          h3: (p) => <h3 className="text-xl font-bold text-white mt-6 mb-2" {...p} />,
          p: (p) => <p className="my-3 text-slate-300" {...p} />,
          ul: (p) => <ul className="list-disc pl-6 my-3 space-y-1.5 text-slate-300" {...p} />,
          ol: (p) => <ol className="list-decimal pl-6 my-3 space-y-1.5 text-slate-300" {...p} />,
          li: (p) => <li className="text-slate-300" {...p} />,
          a: (p) => <a className="text-amber-400 hover:text-amber-300 underline" target="_blank" rel="noreferrer" {...p} />,
          strong: (p) => <strong className="text-white font-semibold" {...p} />,
          em: (p) => <em className="text-amber-200" {...p} />,
          code: (p) => <code className="px-1.5 py-0.5 rounded bg-white/10 text-amber-300 text-sm" {...p} />,
          blockquote: (p) => <blockquote className="border-l-4 border-amber-500 pl-4 italic text-slate-300 my-4" {...p} />,
          hr: () => <hr className="my-6 border-white/10" />,
          img: (p) => <img className="rounded-xl my-4 max-w-full" alt="" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
